const TOKEN_KEY = 'lika:access_token';

export const storage = {
  setToken: (token: string): void => {
    sessionStorage.setItem(TOKEN_KEY, token);
  },

  getToken: (): string | null => {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  removeToken: (): void => {
    sessionStorage.removeItem(TOKEN_KEY);
  },

  hasToken: (): boolean => {
    return !!storage.getToken();
  },
};
